import type { Candidate, Opportunity, Position } from '@axiom/validation';
import type { ApiError } from '@axiom/ui';

import { MlRecommendationsApi } from '../../api/ml-recommendations-api';
import { OpportunityLegacyApi } from '../../api/opportunity-legacy-api';
import { CandidateOpportunityLegacyApi } from '../../api/candidate-opportunity-legacy-api';
import { AddTalentUtil } from '../../utils/AddTalentUtil';

export const OpportunityTalentUtil = {
  reassignPosition: async ({
    opportunityId,
    candidateId,
    positionId,
    isMlRecommendation,
  }: {
    opportunityId: Opportunity['id'];
    candidateId: Candidate['id'];
    positionId?: Position['id'];
    isMlRecommendation: boolean;
  }): Promise<void> => {
    try {
      if (isMlRecommendation) {
        const { data: response } =
          await OpportunityLegacyApi.createOpportunityCandidates(
            opportunityId,
            {
              candidateIds: [candidateId],
              positionId,
            }
          );

        await OpportunityLegacyApi.updateOpportunityCandidate(
          opportunityId,
          candidateId,
          {
            previousCandidateStatus: 'AiSuggested',
          }
        );

        const candidateOpportunityId =
          response.find(co => co.candidateId === candidateId)?.id ?? null;

        await MlRecommendationsApi.updateRecommendation({
          opportunityId,
          candidateId,
          candidateOpportunityId,
        });
      } else {
        await OpportunityLegacyApi.updateOpportunityCandidate(
          opportunityId,
          candidateId,
          {
            positionId,
          }
        );
      }

      await OpportunityLegacyApi.updateBurdendedCost(
        opportunityId,
        candidateId
      );
    } catch (e) {
      AddTalentUtil.addApiErrorToast(e as ApiError);
    }

    await Promise.all([
      OpportunityLegacyApi.refreshOpportunityCandidates(opportunityId),
      OpportunityLegacyApi.refreshOpportunityPositions(opportunityId),
      CandidateOpportunityLegacyApi.refreshCandidateOpportunities(candidateId),
      MlRecommendationsApi.refreshRecommendations(opportunityId),
    ]);
  },
};
